// extracted by mini-css-extract-plugin
module.exports = {"inductee-impact-hero":"InducteeImpactHero_inductee-impact-hero__Vj_z6"};